export type TimeSlot = {
  id: string;
  index: string;
  tag: string;
  tagEn: string;
  name: string;
  subtitle: string;
  desc: string;
  timeline: string;
  focus: string[];
  alert: string;
  primary: boolean;
};

export const timeSlots: TimeSlot[] = [
  {
    id: 'monday',
    index: '01',
    tag: '周一见',
    tagEn: 'MONDAY',
    name: '周一见：一周开瓜第一棒',
    subtitle: '每周一清晨 · 定档与实锤集中放送',
    desc: '周一是一周瓜田的开场哨。综艺定档、新剧官宣、热门 CP 营业首料往往集中在此刻放送，是判断这一周话题走向的关键节点。',
    timeline: '08:30 · 首发预告 → 10:00 · 实锤放送 → 21:00 · 二次发酵',
    focus: ['定档官宣', '新剧开机', '营业首料', '周一复盘'],
    alert: '本周一已过，下一轮周一见聚焦定档官宣与开机动态。',
    primary: true,
  },
  {
    id: 'friday',
    index: '02',
    tag: '周五晚',
    tagEn: 'FRIDAY',
    name: '周五晚：节目正片夜聊时段',
    subtitle: '每周五晚间 · 正片上线与路透热聊',
    desc: '周五晚是各大综艺与真人秀的正片夜。从路透花絮到正片名场面，弹幕与热搜会在这几个小时里急速升温，是吃瓜热度最集中的时段之一。',
    timeline: '18:00 · 片单出炉 → 20:00 · 正片上线 → 22:30 · 热搜发酵',
    focus: ['综艺正片', '名场面', '路透对比', '弹幕热聊'],
    alert: '本周五晚蹲定多档真人秀正片，热度集中在 20:00–23:00。',
    primary: false,
  },
  {
    id: 'weekend',
    index: '03',
    tag: '周末大瓜',
    tagEn: 'WEEKEND',
    name: '周末大瓜：双日持续蹲守',
    subtitle: '周六周日 · 深度爆料与连续剧式瓜',
    desc: '周末流量最高，也最容易催生"连续剧式大瓜"。从周六预热到周日第二落点，适合安排深度盘点与多线并行的吃瓜计划。',
    timeline: '周六 10:00 · 预热 → 周六 20:00 · 第一落点 → 周日 15:00 · 第二落点',
    focus: ['深度爆料', '反转续集', '多线瓜', '周日汇总'],
    alert: '本周末预告有两路线索可能升级为大瓜，建议保留整块蹲守时间。',
    primary: false,
  },
  {
    id: 'month-end',
    index: '04',
    tag: '月末盘点',
    tagEn: 'MONTHLY',
    name: '月末盘点：月度话题总清算',
    subtitle: '每月最后一周 · 数据复盘与热度榜',
    desc: '月末盘点是月度热度的总清算。把四周的定档、营业、口碑和争议拉成榜单，用数据看清这个月谁在持续发力、谁又高开低走。',
    timeline: '倒数第3天 · 数据采集 → 倒数第2天 · 榜单成型 → 月末 · 盘点放送',
    focus: ['月度热度榜', '口碑复盘', '话题趋势', '高开低走追踪'],
    alert: '本月度盘点将聚焦暑期档爆款与新剧口碑分化两个方向。',
    primary: false,
  },
  {
    id: 'quarter',
    index: '05',
    tag: '季度压轴',
    tagEn: 'QUARTERLY',
    name: '季度压轴：Q季度终极大瓜',
    subtitle: '每季收官 · 年度级压轴盘点',
    desc: '季度压轴是年度瓜田的"中场大战"。把整季的爆点、神反转与年度话题候选一次性摊开，堪称季度末最值得提前预约蹲守的时间节点。',
    timeline: '季末前两周 · 预热话题 → 季末 · 压轴盘点 → 次季 · 趋势预告',
    focus: ['年度瓜候选', '季度爆点', '神反转复盘', '次季预告'],
    alert: '季度压轴前会提前放出话题预告，记得开启订阅锁定蹲位。',
    primary: false,
  },
];

export type FlashItem = {
  id: number;
  time: string;
  date: string;
  tag: string;
  tagTone: 'primary' | 'accent' | 'secondary';
  title: string;
  summary: string;
};

export const flashNews: FlashItem[] = [
  {
    id: 1,
    time: '刚刚',
    date: '09-08 21:30',
    tag: '周五晚',
    tagTone: 'primary',
    title: '多档周末真人秀定档名单流出，周五晚蹲守名单扩充',
    summary: '片方集中官宣开播日期，弹幕党与路透党已经提前锁定本周热点位。',
  },
  {
    id: 2,
    time: '40分钟前',
    date: '09-08 20:50',
    tag: '新瓜速报',
    tagTone: 'accent',
    title: '周末预告：两路线索被拍到同框，疑似"连续剧"节奏开启',
    summary: '爆料方称周末或有第二落点，评论区热度已开始预演反转剧本。',
  },
  {
    id: 3,
    time: '2小时前',
    date: '09-08 19:12',
    tag: '热搜预警',
    tagTone: 'secondary',
    title: '晚间词条迅速爬升，吃瓜群众蹲守时间轴被不断刷新',
    summary: '从片花到弹幕的二次创作持续扩散，夜间时段预计迎来讨论高峰。',
  },
  {
    id: 4,
    time: '4小时前',
    date: '09-08 17:05',
    tag: '月末预告',
    tagTone: 'primary',
    title: '月末盘点进入数据采集期，暑期档话题趋势已初现轮廓',
    summary: '本月盘点将重点复盘口碑分化与高开低走样本，提前公布三个观察维度。',
  },
  {
    id: 5,
    time: '今天',
    date: '09-08 11:26',
    tag: '周一复盘',
    tagTone: 'accent',
    title: '本周一定档官宣盘点：新剧开机与新综艺筹备集中提速',
    summary: '多个项目赶在Q3尾巴官宣，为季度压轴提前埋下可蹲守的线索。',
  },
  {
    id: 6,
    time: '昨天',
    date: '09-07 22:40',
    tag: '周末预警',
    tagTone: 'secondary',
    title: '季度压轴话题预热提前启动，年度瓜候选名单浮出水面',
    summary: '距离本季收官还有两周，瓜田已经开始盘点谁能入选年度话题。',
  },
];

export type RankItem = {
  id: number;
  no: number;
  trend: 'up' | 'down' | 'flat';
  title: string;
  heat: string;
  tag: string;
};

export type RankGroup = {
  key: string;
  label: string;
  items: RankItem[];
};

export const rankGroups: RankGroup[] = [
  {
    key: 'week',
    label: '周榜',
    items: [
      { id: 1, no: 1, trend: 'up', title: '周末"连续剧"线索双线并进', heat: '98.6', tag: '周末大瓜' },
      { id: 2, no: 2, trend: 'up', title: '周五晚综艺名场面刷屏', heat: '95.1', tag: '周五晚' },
      { id: 3, no: 3, trend: 'flat', title: '周一定档新剧讨论走高', heat: '91.3', tag: '周一见' },
      { id: 4, no: 4, trend: 'up', title: '路透 vs 正片对比成新梗', heat: '87.8', tag: '周五晚' },
      { id: 5, no: 5, trend: 'down', title: '暑期档口碑高开低走复盘', heat: '82.4', tag: '月末盘点' },
      { id: 6, no: 6, trend: 'up', title: '弹幕二创带热冷门片段', heat: '76.9', tag: '周末大瓜' },
    ],
  },
  {
    key: 'month',
    label: '月榜',
    items: [
      { id: 1, no: 1, trend: 'up', title: '暑期档爆剧承包整个八月话题', heat: '99.0', tag: '月末盘点' },
      { id: 2, no: 2, trend: 'up', title: '多档真人秀收官带动路透热', heat: '94.6', tag: '周五晚' },
      { id: 3, no: 3, trend: 'flat', title: '新剧口碑分化引发讨论', heat: '89.2', tag: '月末盘点' },
      { id: 4, no: 4, trend: 'down', title: '热门 CP 营业节奏放缓', heat: '81.5', tag: '周一见' },
      { id: 5, no: 5, trend: 'up', title: '季度压轴话题提前预热', heat: '78.3', tag: '季度压轴' },
      { id: 6, no: 6, trend: 'flat', title: '综艺售后物料持续上新', heat: '72.8', tag: '周末大瓜' },
    ],
  },
  {
    key: 'all',
    label: '总榜',
    items: [
      { id: 1, no: 1, trend: 'up', title: '暑期档爆剧成就年度级话题', heat: '99.8', tag: '季度压轴' },
      { id: 2, no: 2, trend: 'up', title: '周末大瓜"反转续集"样本', heat: '97.4', tag: '周末大瓜' },
      { id: 3, no: 3, trend: 'flat', title: '周五晚弹幕名场面总集', heat: '93.0', tag: '周五晚' },
      { id: 4, no: 4, trend: 'down', title: '周一定档流量复盘', heat: '86.6', tag: '周一见' },
      { id: 5, no: 5, trend: 'up', title: '月度热度榜方法论沉淀', heat: '80.1', tag: '月末盘点' },
      { id: 6, no: 6, trend: 'up', title: '年度瓜候选名单持续扩充', heat: '75.9', tag: '季度压轴' },
    ],
  },
];

export type ColumnCard = {
  id: number;
  slot: string;
  slotTone: 'primary' | 'accent' | 'secondary';
  title: string;
  lead: string;
  reads: string;
  minutes: string;
  img: string;
};

export const columnGroups: Record<string, { name: string; items: ColumnCard[] }> = {
  monday: {
    name: '周一见 · 定档与官宣',
    items: [
      {
        id: 1,
        slot: '周一见',
        slotTone: 'primary',
        title: '新剧扎堆官宣，谁才是 Q4 档期种子选手',
        lead: '从开机到定档的节奏盘点，帮你在周一开市前锁定本周最值得跟进的项目。',
        reads: '3.2万',
        minutes: '6',
        img: 'https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20scene%20of%20a%20film%20production%20set%20with%20clapperboard%20and%20warm%20tungsten%20lighting%2C%20golden%20hour%20atmosphere%2C%20backstage%20crew%20silhouettes%2C%20soft%20film%20grain%2C%20vintage%20magazine%20reportage%20style%2C%20cozy%20amber%20and%20cream%20tones%2C%20shallow%20depth%20of%20field&width=800&height=520&seq=dagua-col-monday-01&orientation=landscape',
      },
      {
        id: 2,
        slot: '周一见',
        slotTone: 'primary',
        title: '周一开市指南：本周综艺定档总预览',
        lead: '把本周所有定档与营业首料拉成一张清单，标注可蹲时间点，避免错过第一落点。',
        reads: '1.8万',
        minutes: '4',
        img: 'https://readdy.ai/api/search-image?query=warm%20editorial%20photography%20of%20a%20handwritten%20weekly%20schedule%20planner%20on%20a%20wooden%20desk%20with%20coffee%20cup%20and%20reading%20glasses%2C%20soft%20morning%20sunlight%20through%20window%2C%20cozy%20cream%20and%20amber%20tones%2C%20magazine%20lifestyle%20reportage%2C%20shallow%20depth%20of%20field%2C%20film%20grain&width=800&height=520&seq=dagua-col-monday-02&orientation=landscape',
      },
    ],
  },
  friday: {
    name: '周五晚 · 正片与热聊',
    items: [
      {
        id: 3,
        slot: '周五晚',
        slotTone: 'accent',
        title: '正片上线前 30 分钟，老瓜民都先看什么',
        lead: '一份周五晚蹲守操作清单：从片花回放到弹幕预判，让名场面不被你错过。',
        reads: '4.1万',
        minutes: '7',
        img: 'https://readdy.ai/api/search-image?query=warm%20cinematic%20scene%20of%20a%20cozy%20living%20room%20at%20night%20with%20a%20large%20glowing%20television%20screen%20and%20sofa%2C%20popcorn%20and%20phone%20on%20table%2C%20soft%20amber%20lamp%20light%2C%20editorial%20lifestyle%20reportage%2C%20warm%20orange%20and%20cream%20tones%2C%20shallow%20depth%20of%20field%2C%20film%20grain&width=800&height=520&seq=dagua-col-friday-01&orientation=landscape',
      },
      {
        id: 4,
        slot: '周五晚',
        slotTone: 'accent',
        title: '路透 vs 正片：哪些名场面其实是剪辑的艺术',
        lead: '拆解正片剪辑与路透差异背后的叙事逻辑，帮你更懂这一晚的热搜从哪来。',
        reads: '2.7万',
        minutes: '5',
        img: 'https://readdy.ai/api/search-image?query=warm%20editorial%20photography%20of%20a%20video%20editing%20timeline%20and%20camera%20lens%20on%20a%20desk%2C%20film%20reel%20metaphor%2C%20warm%20tungsten%20lighting%2C%20vintage%20magazine%20reportage%20aesthetic%2C%20cozy%20amber%20and%20cream%20tones%2C%20shallow%20depth%20of%20field&width=800&height=520&seq=dagua-col-friday-02&orientation=landscape',
      },
    ],
  },
  weekend: {
    name: '周末大瓜 · 深度与反转',
    items: [
      {
        id: 5,
        slot: '周末大瓜',
        slotTone: 'secondary',
        title: '连续剧式大瓜：如何在不剧透的前提下蹲守反转',
        lead: '双日蹲守策略拆解，周六预热与周日第二落点之间，藏着怎样的节奏密码。',
        reads: '5.6万',
        minutes: '8',
        img: 'https://readdy.ai/api/search-image?query=warm%20cinematic%20scene%20of%20a%20large%20concert%20crowd%20silhouette%20seen%20from%20behind%20with%20stage%20lights%20glowing%20amber%20and%20gold%2C%20energetic%20atmosphere%2C%20bokeh%20lights%2C%20editorial%20reportage%20style%2C%20warm%20orange%20and%20cream%20tones%2C%20film%20grain&width=800&height=520&seq=dagua-col-weekend-01&orientation=landscape',
      },
      {
        id: 6,
        slot: '周末大瓜',
        slotTone: 'secondary',
        title: '周末热度最高时段图鉴：几点发料最有梗',
        lead: '结合历史热度曲线，画一张周末最佳蹲守时间表，让每一次讨论都不落空。',
        reads: '3.9万',
        minutes: '6',
        img: 'https://readdy.ai/api/search-image?query=warm%20editorial%20photography%20of%20a%20large%20analog%20clock%20surrounded%20by%20small%20screens%20and%20phones%20showing%20rising%20line%20charts%2C%20warm%20golden%20light%2C%20magazine%20concept%20art%20style%2C%20cozy%20amber%20and%20cream%20tones%2C%20film%20grain&width=800&height=520&seq=dagua-col-weekend-02&orientation=landscape',
      },
    ],
  },
  monthly: {
    name: '月末盘点 · 数据与复盘',
    items: [
      {
        id: 7,
        slot: '月末盘点',
        slotTone: 'primary',
        title: '月度热度榜方法论：我们如何衡量一个月的瓜',
        lead: '从话题广度、持续时间到口碑曲线，拆解月度盘点背后的数据观察维度。',
        reads: '2.2万',
        minutes: '7',
        img: 'https://readdy.ai/api/search-image?query=warm%20editorial%20photography%20of%20an%20analyst%20desk%20with%20stacked%20papers%2C%20printed%20charts%20and%20a%20warm%20desk%20lamp%2C%20someone%20reviewing%20monthly%20reports%2C%20cozy%20amber%20and%20cream%20tones%2C%20vintage%20magazine%20reportage%2C%20shallow%20depth%20of%20field&width=800&height=520&seq=dagua-col-month-01&orientation=landscape',
      },
      {
        id: 8,
        slot: '月末盘点',
        slotTone: 'primary',
        title: '暑期档高开低走复盘：热度衰减的三个信号',
        lead: '用真实热度曲线回看整个暑期，找出口碑分化与后劲不足的共性问题。',
        reads: '1.9万',
        minutes: '6',
        img: 'https://readdy.ai/api/search-image?query=warm%20editorial%20scene%20of%20a%20declining%20trend%20line%20drawn%20in%20marker%20on%20paper%20against%20soft%20warm%20bokeh%20background%2C%20concept%20of%20data%20reflection%2C%20magazine%20editorial%20style%2C%20cozy%20amber%20and%20cream%20tones%2C%20film%20grain&width=800&height=520&seq=dagua-col-month-02&orientation=landscape',
      },
    ],
  },
  quarter: {
    name: '季度压轴 · 年度级盘点',
    items: [
      {
        id: 9,
        slot: '季度压轴',
        slotTone: 'accent',
        title: 'Q3 压轴前瞻：哪些话题有机会入选年度瓜田',
        lead: '季度收官前的预热盘点到来了，我们把候选线索一条条铺开，提前占好蹲位。',
        reads: '6.3万',
        minutes: '9',
        img: 'https://readdy.ai/api/search-image?query=warm%20editorial%20photography%20of%20a%20large%20golden%20award-style%20spotlight%20illuminating%20an%20empty%20stage%20with%20warm%20haze%2C%20dramatic%20cinematic%20lighting%2C%20magazine%20concept%20art%2C%20amber%20gold%20and%20cream%20tones%2C%20film%20grain&width=800&height=520&seq=dagua-col-quarter-01&orientation=landscape',
      },
      {
        id: 10,
        slot: '季度压轴',
        slotTone: 'accent',
        title: '一年四个压轴：为什么季度收尾总有大瓜',
        lead: '从排期、宣发到档期节奏，聊聊季度压轴为何天然自带"大瓜体质"。',
        reads: '4.4万',
        minutes: '8',
        img: 'https://readdy.ai/api/search-image?query=warm%20cinematic%20scene%20of%20a%20desktop%20calendar%20with%20four%20season%20tabs%20flipped%20open%20and%20glowing%20warm%20light%2C%20concept%20of%20seasonal%20finale%2C%20cozy%20amber%20and%20cream%20tones%2C%20magazine%20editorial%20style%2C%20shallow%20depth%20of%20field%2C%20film%20grain&width=800&height=520&seq=dagua-col-quarter-02&orientation=landscape',
      },
    ],
  },
};

export type FaqItem = { q: string; a: string };

export const faqs: FaqItem[] = [
  {
    q: '大瓜预警的时间表是怎么划分的？',
    a: '我们把一周和一个月里的娱乐话题爆发点整理成固定节点：周一见锁定定档与官宣，周五晚聚焦正片与热聊，周末大瓜留给深度与反转，月末盘点和季度压轴则负责拉长线的数据复盘。每个节点都有对应的内容更新节奏，方便你按时间线蹲守。',
  },
  {
    q: '"周一见""周五晚"这些说法从哪来？',
    a: '这是网友长期追热点过程中形成的"蹲瓜黑话"。娱乐资讯常在特定时段集中放送，周一多宣布定档、周五多上正片、周末则容易爆发长线话题。大瓜预警把这些时段整理成一张可预期的蹲瓜时间表，让吃瓜更有章法。',
  },
  {
    q: '如何收到每个节点的蹲守提醒？',
    a: '订阅站内快讯即可。每逢周一见、周五晚、周末大瓜、月末盘点或季度压轴临近，我们会在资讯流顶部放送对应节点的预告与话题预览，让你不错过每一路线索。',
  },
  {
    q: '内容会不会剧透、影响我自己刷瓜的乐趣？',
    a: '不会。我们的盘点以话题趋势、定档信息与热度解读为主，尽量不破坏你亲自蹲守和参与讨论的体验。涉及"连续剧"或反转的瓜，我们会用预告方式呈现，把悬念留给你。',
  },
  {
    q: '大瓜预警的榜单和热度是怎么算的？',
    a: '我们综合话题讨论量、持续时间、扩散速度与口碑曲线等多个维度给出参考热度值，分为周榜、月榜与总榜。它更像一份热度观察参考，帮助你判断哪些话题值得长期跟进。',
  },
];

export type StatItem = { value: string; label: string };

export const stats: StatItem[] = [
  { value: '128', label: '本月蹲守话题' },
  { value: '5', label: '固定时间节点' },
  { value: '40万+', label: '累计围观人次' },
  { value: '24h', label: '快讯滚动更新' },
];

export const guideSteps = [
  {
    no: 'STEP 01',
    title: '记住时间节点',
    desc: '周一见、周五晚、周末大瓜、月末盘点、季度压轴——把这五个节点刻进吃瓜生物钟。',
  },
  {
    no: 'STEP 02',
    title: '跟上快讯滚动',
    desc: '进入资讯流即可看到实时更新的最新瓜讯，路透、定档、热搜预警一目了然。',
  },
  {
    no: 'STEP 03',
    title: '开启订阅提醒',
    desc: '订阅后，每个节点临近时都会在顶部收到预告，重要线索不再从指缝溜走。',
  },
];

export const testimonials = [
  {
    name: '前排吃瓜选手',
    role: '追综十年的老瓜民',
    text: '以前全靠自己翻时间线，现在照着时间表蹲，周五晚和周末的瓜一个都没漏过。',
  },
  {
    name: '弹幕十级学者',
    role: '综艺重度观众',
    text: '月末盘点那个口碑曲线特别实用，高开低走的剧我都是先看一眼再决定追不追。',
  },
];